import { useState } from "react";

/*
 * Dark is the default (no data-theme attribute); light is the stored opt-in.
 * The inline script in index.html restores a stored "light" before first
 * paint, so this component only has to read and flip the attribute.
 */
const isLight = () => document.documentElement.dataset.theme === "light";

export function ThemeToggle() {
  const [light, setLight] = useState(isLight);

  const toggle = () => {
    const next = !light;
    if (next) {
      document.documentElement.dataset.theme = "light";
    } else {
      delete document.documentElement.dataset.theme;
    }
    try {
      localStorage.setItem("smb.theme", next ? "light" : "dark");
    } catch {
      // Storage unavailable: the theme still flips for this page view.
    }
    setLight(next);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={light ? "Switch to dark theme" : "Switch to light theme"}
      title={light ? "Switch to dark theme" : "Switch to light theme"}
      className="inline-flex h-7 w-7 items-center justify-center rounded border transition-colors"
      style={{ borderColor: "var(--border)", color: "var(--text-secondary)" }}
    >
      {light ? (
        // Moon: clicking returns to dark.
        <svg aria-hidden width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
      ) : (
        // Sun: clicking switches to light.
        <svg aria-hidden width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32 1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
        </svg>
      )}
    </button>
  );
}
